export const All = { label: '(All)', value: -1 }